import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevronleft",
  "use": "icon-chevronleft-usage",
  "viewBox": "0 0 24.571 64.423",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24.571 64.423\" id=\"icon-chevronleft\">\n<g id=\"icon-chevronleft_chevronleft\">\n\t<polyline style=\"fill:none;stroke:#808080;stroke-width:10;stroke-miterlimit:10;\" points=\"20.069,62.247 5.554,32.211 \n\t\t20.069,2.176 \t\" />\n</g>\n<g id=\"icon-chevronleft_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol